import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "../baseQuery";
import { createCompanyCodeTranslation, createCompanyCodeTranslationArray, getCompanyCodeTranslation } from "../../graphql";

export const getCompanyCodeTranslationApi = createApi({
  reducerPath: "getCompanyCodeTranslation",
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    getCompanyCodeTranslation: builder.query({
      query: (variables) => ({
        body: getCompanyCodeTranslation,
        variables: variables, // Pass type as a variable to the query
      }),
      keepUnusedDataFor: Infinity,
      refetchOnMountOrArgChange: true,
      providesTags: (result, error, { codetype }) => [
        { type: "CodeTranslation", id: codetype },
      ],
    }),
    createCompanyCodeTranslation: builder.mutation({
      query: (variables) => ({ body: createCompanyCodeTranslation, variables }),
      invalidatesTags: (result, error, { codetype }) => [
        { type: "CodeTranslation", id: codetype },
      ],
    }),
    createCompanyCodeTranslationArray: builder.mutation({
      query: (variables) => ({ body: createCompanyCodeTranslationArray, variables }),
      invalidatesTags: (result, error, { codetype }) => [
        { type: "CodeTranslation", id: codetype },
      ],
    }),
  }),
});

export const { useGetCompanyCodeTranslationQuery, useCreateCompanyCodeTranslationMutation, useCreateCompanyCodeTranslationArrayMutation } =
  getCompanyCodeTranslationApi;
